import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import GridForm from "../../components/general/GridForm";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { API_HOST, FORM_TYPE } from "../../helper/Constant";
import LoadingButton from "@mui/lab/LoadingButton";
import { SaveOutlined } from "@mui/icons-material";
import { Commons } from "../../helper/CommonService";
import ShowNotif from "../../components/general/ShowNotif";

function Config() {
    const [isShowNotif, setIsShowNotif] = useState(false);
    const [notifData, setNotifData] = useState({});
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleChange = (propertyName, propertyValue) => {
        setData(prev => ({
            ...prev,
            additional_information: {
                ...prev.additional_information,
                [propertyName]: propertyValue
            }
        }));
    }

    const SubmitData = () => {
        setIsProcessing(true);
        data["additional_information"]["pengumumanDate"] = dayjs(data["additional_information"]["pengumumanDate"]).format("DD MMM YYYY");
        data["additional_information"]["jadwalTest"] = dayjs(data["additional_information"]["jadwalTest"]).format("DD MMM YYYY");
        data["additional_information"]["lastUangDaftar"] = dayjs(data["additional_information"]["lastUangDaftar"]).format("DD MMM YYYY");
        data["additional_information"]["lastUangDaftarUlang"] = dayjs(data["additional_information"]["lastUangDaftarUlang"]).format("DD MMM YYYY");
        data["additional_information"]["lastUploadBerkas"] = dayjs(data["additional_information"]["lastUploadBerkas"]).format("DD MMM YYYY");
        data["additional_information"] = JSON.stringify(data.additional_information);
        Commons.UpdateData(API_HOST + "/tahunajaran/" + data.id, data, true)
            .then((responseData) => {
                setNotifData({
                    "status": "success",
                    "message": "Update data Berhasil"
                });
            })
            .catch((responseErr) => {
                console.log(responseErr);
                setNotifData({
                    "status": "error",
                    "message": "Update data Gagal"
                });
            })
            .finally(() => {
                LoadData();
                setIsShowNotif(true);
                setIsProcessing(false);
            });

    }

    const LoadData = () => {
        setLoading(true);
        Commons.GetData(API_HOST + "/tahunajaran", "isActive=1", true)
            .then((dataResp) => {
                if (dataResp && dataResp.length > 0) {
                    let getAdditionalData = JSON.parse(dataResp[0].additional_information);
                    dataResp[0]["additional_information"] = getAdditionalData;
                    setData(dataResp[0]);
                }
            })
            .catch((errResp) => {
                console.log(errResp);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    useEffect(() => {
        LoadData();
    }, []);

    return (
        <>
            <ShowNotif actionClose={() => { setIsShowNotif(false) }} data={notifData} isShow={isShowNotif}></ShowNotif>
            <Card>
                <CardHeader title="Configuration Management" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <Grid sx={{ padding: '10px' }} container spacing={2}>
                        <GridForm column={6} titleForm={"Tahun Ajaran"} attribute={{ name: "tahunAjaran", value: data?.additional_information?.tahunAjaran }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm type={FORM_TYPE.DATEPICKER} column={6} titleForm={"Tgl Upload Berkas Terakhir"} attribute={{ name: "lastUploadBerkas", value: (data?.additional_information?.lastUploadBerkas) ? dayjs(data.additional_information.lastUploadBerkas) : null, format: "DD MMM YYYY" }} isRequired={true} handleChange={handleChange}></GridForm>

                        <GridForm column={6} titleForm={"Uang Pendaftaran"} attribute={{ name: "uangDaftar", value: data?.additional_information?.uangDaftar }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm type={FORM_TYPE.DATEPICKER} column={6} titleForm={"Tgl Uang Pendaftaran Terakhir"} attribute={{ name: "lastUangDaftar", value: (data?.additional_information?.lastUangDaftar) ? dayjs(data.additional_information.lastUangDaftar) : null, format: "DD MMM YYYY" }} isRequired={true} handleChange={handleChange}></GridForm>

                        <GridForm type={FORM_TYPE.DATEPICKER} column={6} titleForm={"Tgl Test"} attribute={{ name: "jadwalTest", value: (data?.additional_information?.jadwalTest) ? dayjs(data.additional_information.jadwalTest) : null, format: "DD MMM YYYY" }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={6} titleForm={"Tempat Test"} attribute={{ name: "tempatTest", value: data?.additional_information?.tempatTest, rows: 3, multiline: true }} isRequired={true} handleChange={handleChange}></GridForm>

                        <GridForm column={6} titleForm={"Waktu Test"} attribute={{ name: "waktuTest", value: data?.additional_information?.waktuTest }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm type={FORM_TYPE.DATEPICKER} column={6} titleForm={"Tgl Pengumuman Test"} attribute={{ name: "pengumumanDate", value: (data?.additional_information?.pengumumanDate) ? dayjs(data.additional_information.pengumumanDate) : null, format: "DD MMM YYYY" }} isRequired={true} handleChange={handleChange}></GridForm>

                        <GridForm column={6} titleForm={"WA Contact Us"} attribute={{ name: "waParam", value: data?.additional_information?.waParam, rows: 3, multiline: true }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={6} titleForm={"Nomor WA"} attribute={{ name: "noWA", value: data?.additional_information?.noWA, type: "number" }} isRequired={true} handleChange={handleChange}></GridForm>

                        <GridForm column={6} titleForm={"Info Pembayaran"} attribute={{ name: "infoBayar", value: data?.additional_information?.infoBayar, rows: 3, multiline: true }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={6} titleForm={"Uang Daftar Ulang"} attribute={{ name: "uangDaftarUlang", value: data?.additional_information?.uangDaftarUlang, rows: 3, multiline: true }} isRequired={true} handleChange={handleChange}></GridForm>

                        <GridForm type={FORM_TYPE.DATEPICKER} column={6} titleForm={"Tgl Uang Daftar Ulang Terakhir"} attribute={{ name: "lastUangDaftarUlang", value: (data?.additional_information?.lastUangDaftarUlang) ? dayjs(data.additional_information.lastUangDaftarUlang) : null, format: "DD MMM YYYY" }} isRequired={true} handleChange={handleChange}></GridForm>
                    </Grid>
                    <LoadingButton
                        fullWidth
                        loading={isProcessing}
                        loadingPosition="start"
                        variant="contained"
                        onClick={SubmitData}
                        startIcon={<SaveOutlined></SaveOutlined>}
                    >
                        {isProcessing ? "Processing" : "Update Data"}
                    </LoadingButton>

                </CardContent>
            </Card>
        </>
    )
}

export default Config;